import React, { useEffect, useState } from 'react'
import TemplateVariableCard from '../../../Templates/TemplateVariableCard'
import {
    useVariable,
    useTitleVariable,
    detectTemplateVariables,
    detectTitleVariables
} from "../../../Helpers/Functions/Templates"

export default function CreateTemplateModal({close, create, saving}) {
    const [template, setTemplate] = useState({title: '', content: '', user_id: 1})
    const [templateVariable, setTemplateVariable] = useState(false)
    const [senderVariable, setSenderVariable] = useState([])
    const [receiverVariable, setReceiverVariable] = useState([])
    const [donorFields, setDonorFields] = useState([])
    const [beneficiaryFields, setBeneficiaryFields] = useState([])
    const [organizationVariable, setOrganizationVariable] = useState(['name'])
    const [totalVariables, setTotalVariables] = useState([])
    const [titleVariables, setTitleVariables] = useState(false)

    useEffect(() => {
        detectTitleVariables(template, setTitleVariables)
        detectTemplateVariables(template, setTemplateVariable)
        clearVariables()
        arrangeVariables()
    }, [template])

    const arrangeVariables = () => {
        setReceiverVariable(['first_name', 'last_name', 'email', 'username', 'birthday', 'bio'])
        setSenderVariable(['first_name', 'last_name', 'email', 'username', 'birthday', 'bio'])
    }

    const clearVariables = () => {
        setDonorFields([])
        setBeneficiaryFields([])
        setReceiverVariable([])
        setSenderVariable([])
        setTotalVariables([])
    }

    const verifyTemplateInputs = () => {
        if (!template.title || template.title.length < 1) {
            Alert.show('error', 'Title is required')
            return
        }

        if (!template.content || template.content.length < 1) {
            Alert.show('error', 'Content is required')
            return
        }

        create(template)
    }
  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center" style={{maxWidth: '90%', width: '1000px'}}>
                <div>
                    <div className="form-group">
                        <label htmlFor="title">Title</label>
                        <input className="form-control" type="text" name="title" id="title"
                            value={template.title}
                            onChange={e => {setTemplate({...template, title: e.target.value})}}
                        />

                        {titleVariables &&
                            <div style={{textAlign: 'left'}}>
                                <TemplateVariableCard 
                                    senderVariables={senderVariable}
                                    receiverVariables={receiverVariable} 
                                    organizationVariable={organizationVariable}
                                    useVariable={(value) => useTitleVariable(value, template, setTemplate, setTitleVariables)} 
                                    realign={true}
                                />
                            </div>
                        }
                    </div>

                    <div className="form-group">
                        <label htmlFor="body">Content</label>
                        <textarea className="form-control textarea" name="content" id="content" rows={8}
                            value={template.content}
                            onChange={e => setTemplate({...template, content: e.target.value})}
                        ></textarea>

                        {templateVariable &&
                            <div style={{textAlign: 'left', height: '400px'}}>
                                <TemplateVariableCard 
                                    senderVariables={senderVariable}
                                    receiverVariables={receiverVariable} 
                                    organizationVariable={organizationVariable}
                                    useVariable={(value) => useVariable(value, template, setTemplate, setTemplateVariable)} 
                                    realign={true}
                                />
                            </div>
                        }
                    </div>
                </div>

                <div className="pt-3">
                    <button 
                        onClick={verifyTemplateInputs} 
                        type="button" 
                        className="btn btn-primary mr-2" 
                        disabled={!template.title || !template.content || saving}
                    >
                        {saving ? 'Creating...' : 'Create'}
                    </button>

                    <button onClick={close} type="button" className="btn btn-secondary mr-2" disabled={saving}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
